const WhatWeDoHero = () => {
  return (
    <section className="relative bg-white py-20 overflow-hidden">
      {/* Tech pattern background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-blue-500"
            style={{
              width: `${Math.random() * 8 + 3}px`,
              height: `${Math.random() * 8 + 3}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              opacity: Math.random() * 0.3 + 0.1,
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 mb-4">
            <div className="h-px w-10 bg-gradient-to-r from-blue-400 to-blue-600"></div>
            <span className="text-sm font-medium text-blue-600 uppercase tracking-wider">Our Services</span>
            <div className="h-px w-10 bg-gradient-to-r from-blue-600 to-blue-400"></div>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Accelerating Digital Innovation</h1>

          <p className="text-xl text-gray-600 mb-8">
            We help businesses transform and thrive in the digital era with cutting-edge technology solutions and expert
            talent.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <button className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-8 py-3 rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg">
              Explore Services
            </button>
            <button className="bg-white hover:bg-gray-50 text-gray-900 border border-gray-200 px-8 py-3 rounded-lg font-medium transition-all duration-300 shadow-sm hover:shadow-md">
              Contact Us
            </button>
          </div>
        </div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path
            d="M0 0L48 5.33333C96 10.6667 192 21.3333 288 32C384 42.6667 480 53.3333 576 58.6667C672 64 768 64 864 58.6667C960 53.3333 1056 42.6667 1152 32C1248 21.3333 1344 10.6667 1392 5.33333L1440 0V80H0V0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  )
}

export default WhatWeDoHero
